import { render, staticRenderFns } from "./JdWarehouseDemand.vue?vue&type=template&id=62990e00&scoped=true&"
import script from "./JdWarehouseDemand.vue?vue&type=script&lang=js&"
export * from "./JdWarehouseDemand.vue?vue&type=script&lang=js&"
import style0 from "./style.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./JdWarehouseDemand.vue?vue&type=style&index=1&id=62990e00&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62990e00",
  null
  
)

export default component.exports